import type { NotificationGroup } from './types';

export const detectGroup = (shortType?: string, fallbackType?: string): NotificationGroup => {
  const t = (shortType || fallbackType || '').toLowerCase();
  if (t.startsWith('listings.')) return 'listings';
  if (t.startsWith('offers.')) return 'offers';
  if (t.startsWith('deals.')) return 'deals';
  if (t.startsWith('order.') || t.startsWith('fulfillment.')) return 'orders';
  if (t.startsWith('messages.')) return 'messages';
  if (t.startsWith('reservations.')) return 'reservations';
  if (t.startsWith('transaction.')) return 'transaction';
  return 'other';
};

